<div class="row justify-content-center">
    <div class="col-lg-2 col-md-2 col-6 text-center" *ngFor="let data of clients_logo">
        <img src="{{data.image}}" class="partner avatar avatar-ex-sm" alt="">
    </div>
</div>